import React, { useState } from "react";
import "./approachsection.css";

const ApproachSection = ({ data }) => {
  const [activeTab, setActiveTab] = useState("business");

  const businessView = data.tabs.business;
  const technicalView = data.tabs.technical;

  return (
    <section className="approach-section">

      <div className="approach-section__container">

        {/* =================================
            SECTION HEADING
        ================================= */}

        <div className="approach-section__heading">

          <div className="approach-section__accent"></div>

          <div className="approach-section__heading-content">

            {data.sectionLabel && (
              <div className="approach-section__label">
                {data.sectionLabel}
              </div>
            )}

            <h2>{data.heading}</h2>

          </div>

        </div>


        {/* =================================
            TABS
        ================================= */}

        <div className="approach-tabs">

          <button
            type="button"
            className={`approach-tabs__button ${
              activeTab === "business"
                ? "is-active"
                : ""
            }`}
            onClick={() => setActiveTab("business")}
          >
            {businessView.label}
          </button>

          <button
            type="button"
            className={`approach-tabs__button ${
              activeTab === "technical"
                ? "is-active"
                : ""
            }`}
            onClick={() => setActiveTab("technical")}
          >
            {technicalView.label}
          </button>

        </div>


        {/* =================================
            BUSINESS VIEW
        ================================= */}

        {activeTab === "business" && (
          <div className="approach-business">

            {businessView.cards.map((card) => (
              <article
                className={`approach-card approach-card--${card.theme}`}
                key={card.id}
              >

                {/* Number */}
                <div className="approach-card__number">
                  {card.number}
                </div>


                {/* Content */}
                <div className="approach-card__content">

                  <div className="approach-card__label">
                    {card.label}
                  </div>

                  <h3>{card.title}</h3>

                  <p>{card.description}</p>


                  {/* Tags */}
                  {card.tags?.length > 0 && (
                    <div className="approach-card__tags">

                      {card.tags.map((tag, index) => (
                        <span
                          className="approach-card__tag"
                          key={index}
                        >
                          {tag}
                        </span>
                      ))}

                    </div>
                  )}

                </div>

              </article>
            ))}

          </div>
        )}


        {/* =================================
            TECHNICAL VIEW
        ================================= */}

        {activeTab === "technical" && (
          <div className="approach-technical">

            <img
              src={technicalView.image}
              alt={technicalView.imageAlt}
            />

          </div>
        )}

      </div>

    </section>
  );
};

export default ApproachSection;